import { createFileRoute, redirect } from "@tanstack/react-router"
import { HomePage } from "@/components/pages/HomePage"

import { useAuthStore } from "@/store/auth.store"

export const Route = createFileRoute("/")({
  beforeLoad: () => {
    const { isAuthenticated, user, buyerId, sellerProfileId, sellerCompanyId } = useAuthStore.getState()
    if (!isAuthenticated || !user) return

    const role = user.role?.toUpperCase()
    if (role === "ADMIN") {
      throw redirect({ to: "/dashboard" })
    }
    if (role === "BUYER" && (buyerId || user.buyer?.id)) {
      throw redirect({ to: "/dashboard" })
    }
    if (
      role === "SELLER" &&
      (sellerProfileId || user.employeeProfile?.id) &&
      (sellerCompanyId || user.employeeProfile?.companyId)
    ) {
      throw redirect({ to: "/dashboard" })
    }
  },
  component: HomePage,
})
